<div mat-dialog-title>
  <span>Parse feed</span>
</div>

<div mat-dialog-content>
  <form #f="ngForm" class="d-flex flex-column">

    <label>Feed Source</label>
    <mat-radio-group name="source" [(ngModel)]="feed.source" class="mb-3" (ngModelChange)="updateFeedType()">
      <mat-radio-button *ngFor="let source of feedSourceKL" [value]="source.key" color="primary" class="mr-3">{{source.label}}</mat-radio-button>
    </mat-radio-group>

    <mat-form-field floatLabel="always" color="primary" *ngIf="feed.source === feedSource.YOUTUBE">
      <mat-label>Select type</mat-label>
      <mat-select name="type" [(ngModel)]="feed.feedTypeYT" required>
        <mat-option *ngFor="let type of feedTypeKL" [value]="type.key">{{type.label}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field floatLabel="always" color="primary" *ngIf="feed.feedTypeYT === feedType.CHANNEL">
      <mat-label>Count</mat-label>
      <input name="count" type="number" matInput [(ngModel)]="feed.count" autocomplete="off" />
      <i class="fal fa-info-circle text-info float-right" matTooltip="If count is left blank, all videos from this channel will be ingested. If count is set to 10 for example, 10 most popular videos will be ingested from this channel"></i>
    </mat-form-field>

    <mat-form-field floatLabel="always" color="primary" *ngIf="feed.source === feedSource.YOUTUBE || feed.source === feedSource.RSS">
      <mat-label>Feed URL</mat-label>
      <input name="url" [formControl]="domainControl" matInput required (ngModelChange)="updateFeedUrl($event)" [(ngModel)]="feed.url" autocomplete="off" />
    </mat-form-field>

    <mat-form-field floatLabel="always" color="primary" *ngIf="feed.source === feedSource.UPLOAD">
      <mat-label>Title</mat-label>
      <input name="title" matInput required [(ngModel)]="feed.title" autocomplete="off" />
    </mat-form-field>

    <mat-form-field floatLabel="always" color="primary" *ngIf="feed.source === feedSource.UPLOAD">
      <mat-label>Description</mat-label>
      <input name="description" matInput [(ngModel)]="feed.description"  autocomplete="off" />
    </mat-form-field>

    <mat-form-field *ngIf="feed.source === feedSource.RSS">
      <input matInput [max]="today"
              name="dateFrom"
              [(ngModel)]="feed.dateFrom"
             (dateChange)="dateChange($event)"
             [matDatepicker]="datePublishdAtRef"
             placeholder="Date from">
      <mat-datepicker-toggle matSuffix [for]="datePublishdAtRef"></mat-datepicker-toggle>
      <mat-datepicker #datePublishdAtRef></mat-datepicker>
    </mat-form-field>

    <div class="summary-info-box mb-3" *ngIf="feed.source === feedSource.RSS">
      Number of videos to ingest: <strong>{{videosCount}}</strong>
    </div>

    <ctv-video-upload-preview class="mb-3" *ngIf="feed.source === feedSource.UPLOAD" label="upload video" (fileSelected)="videoFile = $event"
                              (fileCanceled)="videoFile=null"></ctv-video-upload-preview>

    <ctv-image-upload-preview label="upload thumbnail"
                              *ngIf="feed.source === feedSource.UPLOAD"
                              (fileSelected)="thumbnailFile = $event"
                              (fileCanceled)="removeThumbNailImage()"
                              [fileName]="false"
                              [resolutonGreater]="true"
                              [allowedFileTypes]="'image/png, image/jpeg'"
                              [tooltip]="'PNG or JPG, 480x360'"
                              [resolutionWidth]="'480'"
                              [resolutionHeight]="'360'"
                              [imagePreview]="thumbnailFile"></ctv-image-upload-preview>

    <mat-form-field floatLabel="always" color="primary" *ngIf="feed.newPlaylist">
      <mat-label>New collection name</mat-label>
      <input name="playlistName" matInput [(ngModel)]="feed.newPlaylistName" autocomplete="off" required />
    </mat-form-field>

    <div class="row" *ngIf="feed.newPlaylist">
      <div class="col-lg-6 col-md-6">
        <label>Playlist poster</label><br/>
        <button type="button"
                mat-flat-button
                (click)="posterInput.click()"
                class="iconed">
          <i class="fas fa-cloud-upload-alt"></i>
          Upload
        </button>
        <input hidden (change)="onFileSelected()" #posterInput type="file" id="poster">
      </div>

      <div class="col-lg-6 col-md-6">
        <label>Playlist image</label><br/>
        <button type="button"
                mat-flat-button
                (click)="imageInput.click()"
                class="iconed">
          <i class="fas fa-cloud-upload-alt"></i>
          Upload
        </button>
        <input hidden (change)="onFileSelected()" #imageInput type="file" id="image">
      </div>
    </div>

    <!-- <div mat-dialog-content class="py-1" *ngIf="!feed.newPlaylist">
      <ctv-playlist-autocomplete-chips (playlistSelectionChange)="onPlaylistsSelected($event)"></ctv-playlist-autocomplete-chips>
    </div> -->

    <ctv-categories-multi-select [selectedCategory]="feed.category"
                                 (categorySelected)="feed.category = $event" *ngIf="feed.newPlaylist">
    </ctv-categories-multi-select>

    <label *ngIf="!videoType">Owner type</label>
    <mat-radio-group name="ownerType" [(ngModel)]="feed.ownerType" class="mb-3" (change)="feed.ownerId = null" *ngIf="!videoType">
      <mat-radio-button color="primary" class="mr-3" *ngFor="let ownerType of ownerTypeKL" value="{{ownerType.key}}">{{ownerType.label}}</mat-radio-button>
    </mat-radio-group>

    <ctv-publisher-autocomplete (publisherSelected)="setOwnerId($event)" *ngIf="feed.ownerType === ownerType.PUBLISHER && !videoType"></ctv-publisher-autocomplete>

    <ctv-content-owner-autocomplete (contentOwnerSelected)="setOwnerId($event)"  *ngIf="feed.ownerType === ownerType.CONTENT_OWNER && !videoType"></ctv-content-owner-autocomplete>
  </form>
</div>

<div mat-dialog-actions>
  <button mat-stroked-button class="" [mat-dialog-close]="false">
    Cancel
  </button>
  <button mat-flat-button color="primary"
          [disabled]="!f.valid || !feed.ownerType || !domainControl.valid || (!feed.category && feed.newPlaylist) ||
                      (feed.ownerType === ownerType.PUBLISHER && !feed.ownerId) ||
                      (feed.ownerType === ownerType.CONTENT_OWNER && !feed.ownerId) ||
                      (feed.source === feedSource.RSS && videosCount === 0)"
          (click)="submit()">
    <span>Finish</span>
  </button>
</div>
